import TemplateView from '../../../../TemplateView'


export default class CardDetailsHeaderButton extends TemplateView {

    constructor({
        title,
        additionalClass,
        onClickCallback,
    }) {
        super()

        this.params = {
            additionalClass,
            onClickCallback,
        }

        this.state = {
            title: title
        }

        this.onStatePropertyChanged('title', (title) => {
            this.$buttonText.text(title)
        })
    }

    templateHtml() {
        return `<div class="buttonContainer <%=additionalClass%>">
                    <div class="buttonIcon"/>
                    <div class="buttonText dashedLink"/>
                </div>`
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
        }
    }

    afterRender() {
        this.getEl().click(this.params.onClickCallback)

        this.$buttonText = this.find('.buttonText.dashedLink')
        this.$buttonText.text(this.state.title)
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/creditCard/CardDetailsHeaderButton.js